import { AxiosResponse } from 'axios';
import { IQrCodeFiles, IQrs } from 'models';
import qs from 'qs';
import IPageable from '../models/IPageable';
import api from '../http';

export default class QrCodesService {
    static async getQrUsers(pageable: IPageable): Promise<AxiosResponse<IQrs>> {
        return api.get('/qr/code', {
            params: {
                ...pageable,
            },
            paramsSerializer: (params) => {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            },
        });
    }

    static async qrUserPost(data: any): Promise<AxiosResponse<void>> {
        return api.post(`/qr/code/temporary`, data);
    }

    static async uploadFile(file: File): Promise<AxiosResponse<IQrCodeFiles>> {
        const formData = new FormData();
        formData.append('file', file);

        return api.post(`/qr/code/temporary/file`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
}
